(function () {
  if (window.__ssCustomilyVyRoseThumbnailOverride) return;
  window.__ssCustomilyVyRoseThumbnailOverride = true;

  var roseGoldPattern = /18K\s+Rose\s+Gold\s+Vermeil/i;
  var customilySwatchPattern = /cdn\.customily\.com\/shopify\/assetFiles\/swatches\//i;
  var loadedScriptSrc = document.currentScript && document.currentScript.src || '';
  var categoryThumbFile = 'ss-vy-dog-breeds-thumb.jpg';
  var observer = null;
  var timer = 0;

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normalized(value) {
    return clean(value).toLowerCase();
  }

  function scriptSrc() {
    if (loadedScriptSrc) return loadedScriptSrc;

    var script = Array.prototype.slice.call(document.scripts).find(function (candidate) {
      return /customily-vy-rose-thumbnail-override(?:-v2)?\.js/i.test(candidate.src || '');
    });
    return script && script.src || '';
  }

  function themeAssetUrl(fileName) {
    var src = scriptSrc();
    if (src && /\/assets\//.test(src)) {
      return src.split('?')[0].replace(/customily-vy-rose-thumbnail-override(?:-v2)?\.js$/i, fileName);
    }
    return '/cdn/shop/t/16/assets/' + fileName;
  }

  function currentMaterial() {
    var checked = document.querySelector('input[name="Material"]:checked');
    return checked ? checked.value : '';
  }

  function isRoseGoldMaterial() {
    return roseGoldPattern.test(currentMaterial());
  }

  function optionName(option) {
    var title = option && option.querySelector('.option_name');
    return clean(title && title.textContent).replace(/\s+\*\s+Required$/i, '');
  }

  function isVyOption(option) {
    return /^V-Y Dog Breeds$/i.test(optionName(option));
  }

  function isBreedCategoryOption(option) {
    return /^Choose Dog Breed #\d+$/i.test(optionName(option));
  }

  function imageSrc(image) {
    return image && (image.currentSrc || image.src || image.getAttribute('src') || '');
  }

  function customilyImages(element) {
    return Array.prototype.slice.call((element || document).querySelectorAll('img.csh-dropdown-label-image, img')).filter(function (image) {
      return customilySwatchPattern.test(imageSrc(image));
    });
  }

  function categoryInput(option, value) {
    return Array.prototype.slice.call((option || document).querySelectorAll('input[type="radio"]')).find(function (input) {
      return normalized(input.value) === normalized(value);
    });
  }

  function swatchScopeForInput(input) {
    if (!input) return null;
    var label = input.id && document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    return label || input.closest('.customily-swatch') || input.parentElement;
  }

  function applyCategoryThumb(image, src) {
    if (!image || !src) return;

    if (imageSrc(image) !== src) {
      image.setAttribute('src', src);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    }

    image.style.objectFit = 'cover';
    image.style.objectPosition = 'center center';
    image.style.removeProperty('transform');
    image.style.removeProperty('transform-origin');
    image.dataset.ssVyCategoryThumb = 'static-v-y';
  }

  function replaceVyCategoryThumb(option) {
    var input = categoryInput(option, 'V-Y Dog Breeds');
    var scope = swatchScopeForInput(input);
    if (!scope) return;

    customilyImages(scope).forEach(function (image) {
      applyCategoryThumb(image, themeAssetUrl(categoryThumbFile));
    });
  }

  function applyElementCrop(image) {
    if (!image) return;

    var frame = image.closest('.csh-dropdown-label, .csh-dropdown-input-container') || image.parentElement;
    if (frame) {
      frame.style.overflow = 'hidden';
    }

    image.style.objectFit = 'cover';
    image.style.objectPosition = 'center center';
    image.style.transform = 'scale(1.18)';
    image.style.transformOrigin = 'center center';
    image.dataset.ssVyRoseThumbOverridden = 'rose-element-crop';
  }

  function sync() {
    Array.prototype.slice.call(document.querySelectorAll('.customily_option')).forEach(function (option) {
      if (isBreedCategoryOption(option)) {
        replaceVyCategoryThumb(option);
      }

      if (isRoseGoldMaterial() && isVyOption(option)) {
        customilyImages(option).forEach(applyElementCrop);
      }
    });
  }

  function boot() {
    sync();

    observer = new MutationObserver(sync);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'class', 'checked', 'style']
    });

    var attempts = 0;
    timer = window.setInterval(function () {
      attempts += 1;
      sync();
      if (attempts > 100) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
